<template>
  <div class="page-service">
    <ml-header title="联系客服" :dark="true" background-color="transparent" />
    <div class="info-container">
      <img
        class="avatar"
        src="../../assets/personal/service_avatar.jpeg"
        alt=""
      />
      <p class="name">官方客服</p>
      <p class="wx-chat">
        微信号：<span>{{ wx }}</span
        ><span v-if="wx" class="copy" v-copy="wx">复制</span>
      </p>
      <img
        class="qr-code"
        :src="`http://qr.topscan.com/api.php?text=${qr}`"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { getServiceInfo } from "@/api/platform";
import toast from "@/utils/toast";

export default {
  name: "Service",
  data() {
    return {
      service: {},
      qr: "https://sadsadsadasdasasdasdadasewqewqxczdasdsaqweq",
      wx: ""
    };
  },
  directives: {
    copy: {
      handleClipboard: null,
      bind(el, binding) {
        binding.def.handleClipboard = function() {
          const inputElement = document.createElement("input");
          inputElement.setAttribute("value", binding.value);
          document.body.appendChild(inputElement);
          inputElement.select();
          document.execCommand("copy");
          toast("已复制客服微信", 1000);
          document.body.removeChild(inputElement);
        };
        el.addEventListener("click", binding.def.handleClipboard);
      },
      unbind(el, binding) {
        el.removeEventListener("click", binding.def.handleClipboard);
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.wx = await getServiceInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-service {
  min-height: 100vh;
  background-image: url("../../assets/personal/service-bg@2x.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .info-container {
    position: relative;
    width: 290px;
    height: 358px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    .avatar {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 78px;
      height: 78px;
      box-shadow: 0 4px 12px 0 rgba(241, 240, 234, 1);
      border: 1px solid rgba(255, 255, 255, 1);
      background: red;
      border-radius: 50%;
    }
    .name {
      margin-top: 54px;
    }
    .wx-chat {
      margin-top: 6px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      .copy {
        margin-left: 20px;
        color: rgba(228, 191, 88, 1);
      }
    }
    .qr-code {
      margin-top: 32px;
      width: 180px;
      height: 180px;
    }
  }
}
</style>
